import React, { useState } from 'react';
import { Box, FlatTextInput, Inscription, LinkButton, RawButton, ResetIcon } from '@common-fe/common-fe';

import { HealthPlanRenewal } from '@/modules/Renewals/renewals.types';
import theme from '@/styles/theme';

import {
  HealthPlanField,
  useEditableHealthPlan,
  useHealthPlanCodeActions,
  useHealthPlanFieldError,
} from '../hooks/useHealthPlanCodeActions';

interface HealthPlanNameProps {
  healthPlan: HealthPlanRenewal;
  showError?: boolean;
  isViewMode?: boolean;
  showEditAction?: boolean;
  testId?: string;
}

const HealthPlanName: React.FC<HealthPlanNameProps> = ({
  healthPlan,
  showError,
  isViewMode,
  showEditAction,
  testId = 'health-plan-name',
}) => {
  const [isEditMode, setEditMode] = useState(false);

  const { updateEntityDebounced, resetEntity } = useHealthPlanCodeActions();
  const editableHealthPlan = useEditableHealthPlan(healthPlan.id);
  const errorText = useHealthPlanFieldError(healthPlan.id, HealthPlanField.Name);

  const displayName =
    isViewMode && !showEditAction ? healthPlan.name : editableHealthPlan?.name || healthPlan.name || '-';

  return (
    <>
      <Box direction="row" align="end">
        <Inscription
          size="20px"
          lineHeight="28px"
          weight="bold"
          color="textBody"
          data-testid={`${testId}_value`}
        >
          {displayName}
        </Inscription>
        {!isEditMode && showEditAction && (
          <LinkButton
            testId={`${testId}_edit-button`}
            linkInlineMode
            style={{ marginLeft: theme.spacings.xxs }}
            onClick={() => setEditMode(true)}
          >
            <Inscription lineHeight="26px">Edit</Inscription>
          </LinkButton>
        )}
      </Box>
      {isEditMode && (
        <Box direction="row" margin={{ vertical: 's' }}>
          <Box width="320px" margin={{ right: 's' }}>
            <FlatTextInput
              onChange={(value) =>
                healthPlan.id && updateEntityDebounced(healthPlan.id, HealthPlanField.Name, value)
              }
              value={editableHealthPlan?.name || ''}
              testId={`${testId}_input`}
              placeholder="Enter Health Plan name"
              errorText={showError ? errorText : undefined}
            />
          </Box>
          <Box style={{ position: 'relative' }}>
            <RawButton
              data-testId={`${testId}_reset-button`}
              onClick={() => healthPlan.id && resetEntity(healthPlan.id, HealthPlanField.Name)}
              style={{ position: 'absolute', top: theme.spacings.spacing12, cursor: 'pointer' }}
            >
              <ResetIcon data-testId={`${testId}_reset-button`} size="16px" color="iconPrimary" />
            </RawButton>
          </Box>
        </Box>
      )}
    </>
  );
};

export default HealthPlanName;
